import React, { useMemo, useRef, useState } from 'react';
import { api } from '../scripts/api';
import CardComponent from '../components/CardComponent';

export default function VinScanPage() {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [vin, setVin] = useState('');
  const [text, setText] = useState('');
  const [rows, setRows] = useState([]);
  const [msg, setMsg] = useState('');

  const scan = async (file) => {
    setBusy(true); setMsg('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await api.post('/ocr', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setText(data.text || '');
      const candidate = (data.candidates || [])[0] || '';
      setVin(candidate);
      if (candidate) {
        const { data: res } = await api.get('/search_by_vin', { params: { v: candidate } });
        setRows([...(res.inventory || []), ...(res.sold_inventory || [])]);
      } else {
        setRows([]);
      }
    } catch (e) {
      console.error('OCR/search failed', e);
      setMsg('OCR/search failed');
      setRows([]);
    } finally {
      setBusy(false);
    }
  };

  const manualSearch = async () => {
    if (!vin) return;
    setBusy(true); setMsg('');
    try {
      const { data: res } = await api.get('/search_by_vin', { params: { v: vin } });
      setRows([...(res.inventory || []), ...(res.sold_inventory || [])]);
    } catch (e) {
      console.error('search failed', e);
      setMsg('Search failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container">
      <div className="row" style={{ flexWrap: 'wrap' }}>
        <input ref={inputRef} type="file" accept="image/*" capture="environment"
               onChange={(e) => e.target.files?.[0] && scan(e.target.files[0])} style={{ display: 'none' }} />
        <button className="btn" onClick={() => inputRef.current?.click()}>Scan VIN</button>
        <input className="input" value={vin} onChange={(e) => setVin(e.target.value)} placeholder="VIN or last-8" />
        <button className="btn-outline" onClick={manualSearch}>Search</button>
      </div>
      {busy && <div className="muted">Working…</div>}
      {msg && <div className="muted">{msg}</div>}

      <div className="space-y">
        {rows.map((r) => (
          <CardComponent key={`vin-${r.id}-${r.rowo || ''}`} record={r} table={r.to_customer !== undefined ? 'inventory' : 'sold_inventory'} />
        ))}
      </div>
    </div>
  );
}
